import * as import_1 from "x12-core/schema";

/**
 * 1365 Service Type Code
 * Code identifying the classification of service
 * Minimum length: 1
 * Maximum length: 2
 */
export enum ServiceTypeCode {
    /**
     * Medical Care
     */
    MEDICAL_CARE = "1",
    /**
     * Surgical
     */
    SURGICAL = "2",
    /**
     * Consultation
     */
    CONSULTATION = "3",
    /**
     * Diagnostic X-Ray
     */
    DIAGNOSTIC_X_RAY = "4",
    /**
     * Diagnostic Lab
     */
    DIAGNOSTIC_LAB = "5",
    /**
     * Radiation Therapy
     */
    RADIATION_THERAPY = "6",
    /**
     * Anesthesia
     */
    ANESTHESIA = "7",
    /**
     * Surgical Assistance
     */
    SURGICAL_ASSISTANCE = "8",
    /**
     * Other Medical
     */
    OTHER_MEDICAL = "9",
    /**
     * Non-escrow or Non-impound Service
     */
    NON_ESCROW_OR_NON_IMPOUND_SERVICE = "B",
    /**
     * Escrow or Impound Service
     */
    ESCROW_OR_IMPOUND_SERVICE = "C",
    /**
     * Blood Charges
     */
    BLOOD_CHARGES = "10",
    /**
     * Used Durable Medical Equipment
     */
    USED_DURABLE_MEDICAL_EQUIPMENT = "11",
    /**
     * Durable Medical Equipment Purchase
     */
    DURABLE_MEDICAL_EQUIPMENT_PURCHASE = "12",
    /**
     * Ambulatory Service Center Facility
     */
    AMBULATORY_SERVICE_CENTER_FACILITY = "13",
    /**
     * Renal Supplies in the Home
     */
    RENAL_SUPPLIES_IN_THE_HOME = "14",
    /**
     * Alternate Method Dialysis
     */
    ALTERNATE_METHOD_DIALYSIS = "15",
    /**
     * Chronic Renal Disease (CRD) Equipment
     */
    CHRONIC_RENAL_DISEASE_CRD_EQUIPMENT = "16",
    /**
     * Pre-Admission Testing
     */
    PRE_ADMISSION_TESTING = "17",
    /**
     * Durable Medical Equipment Rental
     */
    DURABLE_MEDICAL_EQUIPMENT_RENTAL = "18",
    /**
     * Pneumonia Vaccine
     */
    PNEUMONIA_VACCINE = "19",
    /**
     * Second Surgical Opinion
     */
    SECOND_SURGICAL_OPINION = "20",
    /**
     * Third Surgical Opinion
     */
    THIRD_SURGICAL_OPINION = "21",
    /**
     * Social Work
     */
    SOCIAL_WORK = "22",
    /**
     * Diagnostic Dental
     */
    DIAGNOSTIC_DENTAL = "23",
    /**
     * Periodontics
     */
    PERIODONTICS = "24",
    /**
     * Restorative
     */
    RESTORATIVE = "25",
    /**
     * Endodontics
     */
    ENDODONTICS = "26",
    /**
     * Maxillofacial Prosthetics
     */
    MAXILLOFACIAL_PROSTHETICS = "27",
    /**
     * Adjunctive Dental Services
     */
    ADJUNCTIVE_DENTAL_SERVICES = "28",
    /**
     * Health Benefit Plan Coverage
     */
    HEALTH_BENEFIT_PLAN_COVERAGE = "30",
    /**
     * Benefit Disclaimer
     */
    BENEFIT_DISCLAIMER = "31",
    /**
     * Plan Waiting Period
     */
    PLAN_WAITING_PERIOD = "32",
    /**
     * Chiropractic
     */
    CHIROPRACTIC = "33",
    /**
     * Chiropractic Office Visits
     */
    CHIROPRACTIC_OFFICE_VISITS = "34",
    /**
     * Dental Care
     */
    DENTAL_CARE = "35",
    /**
     * Dental Crowns
     */
    DENTAL_CROWNS = "36",
    /**
     * Dental Accident
     */
    DENTAL_ACCIDENT = "37",
    /**
     * Orthodontics
     */
    ORTHODONTICS = "38",
    /**
     * Prosthodontics
     */
    PROSTHODONTICS = "39",
    /**
     * Oral Surgery
     */
    ORAL_SURGERY = "40",
    /**
     * Routine (Preventive) Dental
     */
    ROUTINE_PREVENTIVE_DENTAL = "41",
    /**
     * Home Health Care
     */
    HOME_HEALTH_CARE = "42",
    /**
     * Home Health Prescriptions
     */
    HOME_HEALTH_PRESCRIPTIONS = "43",
    /**
     * Home Health Visits
     */
    HOME_HEALTH_VISITS = "44",
    /**
     * Hospice
     */
    HOSPICE = "45",
    /**
     * Respite Care
     */
    RESPITE_CARE = "46",
    /**
     * Hospital
     */
    HOSPITAL = "47",
    /**
     * Hospital - Inpatient
     */
    HOSPITAL_MINUS_INPATIENT = "48",
    /**
     * Hospital - Room and Board
     */
    HOSPITAL_MINUS_ROOM_AND_BOARD = "49",
    /**
     * Hospital - Outpatient
     */
    HOSPITAL_MINUS_OUTPATIENT = "50",
    /**
     * Hospital - Emergency Accident
     */
    HOSPITAL_MINUS_EMERGENCY_ACCIDENT = "51",
    /**
     * Hospital - Emergency Medical
     */
    HOSPITAL_MINUS_EMERGENCY_MEDICAL = "52",
    /**
     * Hospital - Ambulatory Surgical
     */
    HOSPITAL_MINUS_AMBULATORY_SURGICAL = "53",
    /**
     * Long Term Care
     */
    LONG_TERM_CARE = "54",
    /**
     * Major Medical
     */
    MAJOR_MEDICAL = "55",
    /**
     * Medically Related Transportation
     */
    MEDICALLY_RELATED_TRANSPORTATION = "56",
    /**
     * Air Transportation
     */
    AIR_TRANSPORTATION = "57",
    /**
     * Cabulance
     */
    CABULANCE = "58",
    /**
     * Licensed Ambulance
     */
    LICENSED_AMBULANCE = "59",
    /**
     * General Benefits
     */
    GENERAL_BENEFITS = "60",
    /**
     * In-vitro Fertilization
     */
    IN_VITRO_FERTILIZATION = "61",
    /**
     * MRI/CAT Scan
     */
    MRI_CAT_SCAN = "62",
    /**
     * Donor Procedures
     */
    DONOR_PROCEDURES = "63",
    /**
     * Acupuncture
     */
    ACUPUNCTURE = "64",
    /**
     * Newborn Care
     */
    NEWBORN_CARE = "65",
    /**
     * Pathology
     */
    PATHOLOGY = "66",
    /**
     * Smoking Cessation
     */
    SMOKING_CESSATION = "67",
    /**
     * Well Baby Care
     */
    WELL_BABY_CARE = "68",
    /**
     * Maternity
     */
    MATERNITY = "69",
    /**
     * Transplants
     */
    TRANSPLANTS = "70",
    /**
     * Audiology Exam
     */
    AUDIOLOGY_EXAM = "71",
    /**
     * Inhalation Therapy
     */
    INHALATION_THERAPY = "72",
    /**
     * Diagnostic Medical
     */
    DIAGNOSTIC_MEDICAL = "73",
    /**
     * Private Duty Nursing
     */
    PRIVATE_DUTY_NURSING = "74",
    /**
     * Prosthetic Device
     */
    PROSTHETIC_DEVICE = "75",
    /**
     * Dialysis
     */
    DIALYSIS = "76",
    /**
     * Otological Exam
     */
    OTOLOGICAL_EXAM = "77",
    /**
     * Chemotherapy
     */
    CHEMOTHERAPY = "78",
    /**
     * Allergy Testing
     */
    ALLERGY_TESTING = "79",
    /**
     * Immunizations
     */
    IMMUNIZATIONS = "80",
    /**
     * Routine Physical
     */
    ROUTINE_PHYSICAL = "81",
    /**
     * Family Planning
     */
    FAMILY_PLANNING = "82",
    /**
     * Infertility
     */
    INFERTILITY = "83",
    /**
     * Abortion
     */
    ABORTION = "84",
    /**
     * AIDS
     */
    AIDS = "85",
    /**
     * Emergency Services
     */
    EMERGENCY_SERVICES = "86",
    /**
     * Cancer
     */
    CANCER = "87",
    /**
     * Pharmacy
     */
    PHARMACY = "88",
    /**
     * Free Standing Prescription Drug
     */
    FREE_STANDING_PRESCRIPTION_DRUG = "89",
    /**
     * Mail Order Prescription Drug
     */
    MAIL_ORDER_PRESCRIPTION_DRUG = "90",
    /**
     * Brand Name Prescription Drug
     */
    BRAND_NAME_PRESCRIPTION_DRUG = "91",
    /**
     * Generic Prescription Drug
     */
    GENERIC_PRESCRIPTION_DRUG = "92",
    /**
     * Podiatry
     */
    PODIATRY = "93",
    /**
     * Podiatry - Office Visits
     */
    PODIATRY_MINUS_OFFICE_VISITS = "94",
    /**
     * Podiatry - Nursing Home Visits
     */
    PODIATRY_MINUS_NURSING_HOME_VISITS = "95",
    /**
     * Professional (Physician)
     */
    PROFESSIONAL_PHYSICIAN = "96",
    /**
     * Anesthesiologist
     */
    ANESTHESIOLOGIST = "97",
    /**
     * Professional (Physician) Visit - Office
     */
    PROFESSIONAL_PHYSICIAN_VISIT_MINUS_OFFICE = "98",
    /**
     * Professional (Physician) Visit - Inpatient
     */
    PROFESSIONAL_PHYSICIAN_VISIT_MINUS_INPATIENT = "99",
    /**
     * Professional (Physician) Visit - Outpatient
     */
    PROFESSIONAL_PHYSICIAN_VISIT_MINUS_OUTPATIENT = "A0",
    /**
     * Professional (Physician) Visit - Nursing Home
     */
    PROFESSIONAL_PHYSICIAN_VISIT_MINUS_NURSING_HOME = "A1",
    /**
     * Professional (Physician) Visit - Skilled Nursing Facility
     */
    PROFESSIONAL_PHYSICIAN_VISIT_MINUS_SKILLED_NURSING_FACILITY = "A2",
    /**
     * Professional (Physician) Visit - Home
     */
    PROFESSIONAL_PHYSICIAN_VISIT_MINUS_HOME = "A3",
    /**
     * Psychiatric
     */
    PSYCHIATRIC = "A4",
    /**
     * Psychiatric - Room and Board
     */
    PSYCHIATRIC_MINUS_ROOM_AND_BOARD = "A5",
    /**
     * Psychotherapy
     */
    PSYCHOTHERAPY = "A6",
    /**
     * Psychiatric - Inpatient
     */
    PSYCHIATRIC_MINUS_INPATIENT = "A7",
    /**
     * Psychiatric - Outpatient
     */
    PSYCHIATRIC_MINUS_OUTPATIENT = "A8",
    /**
     * Rehabilitation
     */
    REHABILITATION = "A9",
    /**
     * Rehabilitation - Room and Board
     */
    REHABILITATION_MINUS_ROOM_AND_BOARD = "AA",
    /**
     * Rehabilitation - Inpatient
     */
    REHABILITATION_MINUS_INPATIENT = "AB",
    /**
     * Rehabilitation - Outpatient
     */
    REHABILITATION_MINUS_OUTPATIENT = "AC",
    /**
     * Occupational Therapy
     */
    OCCUPATIONAL_THERAPY = "AD",
    /**
     * Physical Medicine
     */
    PHYSICAL_MEDICINE = "AE",
    /**
     * Speech Therapy
     */
    SPEECH_THERAPY = "AF",
    /**
     * Skilled Nursing Care
     */
    SKILLED_NURSING_CARE = "AG",
    /**
     * Skilled Nursing Care - Room and Board
     */
    SKILLED_NURSING_CARE_MINUS_ROOM_AND_BOARD = "AH",
    /**
     * Substance Abuse
     */
    SUBSTANCE_ABUSE = "AI",
    /**
     * Alcoholism
     */
    ALCOHOLISM = "AJ",
    /**
     * Drug Addiction
     */
    DRUG_ADDICTION = "AK",
    /**
     * Vision (Optometry)
     */
    VISION_OPTOMETRY = "AL",
    /**
     * Frames
     */
    FRAMES = "AM",
    /**
     * Routine Exam
     */
    ROUTINE_EXAM = "AN",
    /**
     * Lenses
     */
    LENSES = "AO",
    /**
     * Nonmedically Necessary Physical
     */
    NONMEDICALLY_NECESSARY_PHYSICAL = "AQ",
    /**
     * Experimental Drug Therapy
     */
    EXPERIMENTAL_DRUG_THERAPY = "AR",
    /**
     * Burn Care
     */
    BURN_CARE = "B1",
    /**
     * Brand Name Prescription Drug - Formulary
     */
    BRAND_NAME_PRESCRIPTION_DRUG_MINUS_FORMULARY = "B2",
    /**
     * Brand Name Prescription Drug - Non-Formulary
     */
    BRAND_NAME_PRESCRIPTION_DRUG_MINUS_NON_FORMULARY = "B3",
    /**
     * Independent Medical Evaluation
     */
    INDEPENDENT_MEDICAL_EVALUATION = "BA",
    /**
     * Partial Hospitalization (Psychiatric)
     */
    PARTIAL_HOSPITALIZATION_PSYCHIATRIC = "BB",
    /**
     * Day Care (Psychiatric)
     */
    DAY_CARE_PSYCHIATRIC = "BC",
    /**
     * Cognitive Therapy
     */
    COGNITIVE_THERAPY = "BD",
    /**
     * Massage Therapy
     */
    MASSAGE_THERAPY = "BE",
    /**
     * Pulmonary Rehabilitation
     */
    PULMONARY_REHABILITATION = "BF",
    /**
     * Cardiac Rehabilitation
     */
    CARDIAC_REHABILITATION = "BG",
    /**
     * Pediatric
     */
    PEDIATRIC = "BH",
    /**
     * Nursery
     */
    NURSERY = "BI",
    /**
     * Skin
     */
    SKIN = "BJ",
    /**
     * Orthopedic
     */
    ORTHOPEDIC = "BK",
    /**
     * Cardiac
     */
    CARDIAC = "BL",
    /**
     * Lymphatic
     */
    LYMPHATIC = "BM",
    /**
     * Gastrointestinal
     */
    GASTROINTESTINAL = "BN",
    /**
     * Endocrine
     */
    ENDOCRINE = "BP",
    /**
     * Neurology
     */
    NEUROLOGY = "BQ",
    /**
     * Eye
     */
    EYE = "BR",
    /**
     * Invasive Procedures
     */
    INVASIVE_PROCEDURES = "BS",
    /**
     * Gynecological
     */
    GYNECOLOGICAL = "BT",
    /**
     * Obstetrical
     */
    OBSTETRICAL = "BU",
    /**
     * Obstetrical/Gynecological
     */
    OBSTETRICAL_GYNECOLOGICAL = "BV",
    /**
     * Mail Order Prescription Drug: Brand Name
     */
    MAIL_ORDER_PRESCRIPTION_DRUG_BRAND_NAME = "BW",
    /**
     * Mail Order Prescription Drug: Generic
     */
    MAIL_ORDER_PRESCRIPTION_DRUG_GENERIC = "BX",
    /**
     * Physician Visit - Office: Sick
     */
    PHYSICIAN_VISIT_MINUS_OFFICE_SICK = "BY",
    /**
     * Physician Visit - Office: Well
     */
    PHYSICIAN_VISIT_MINUS_OFFICE_WELL = "BZ",
    /**
     * Coronary Care
     */
    CORONARY_CARE = "C1",
    /**
     * Private Duty Nursing - Inpatient
     */
    PRIVATE_DUTY_NURSING_MINUS_INPATIENT = "CA",
    /**
     * Private Duty Nursing - Home
     */
    PRIVATE_DUTY_NURSING_MINUS_HOME = "CB",
    /**
     * Surgical Benefits - Professional (Physician)
     */
    SURGICAL_BENEFITS_MINUS_PROFESSIONAL_PHYSICIAN = "CC",
    /**
     * Surgical Benefits - Facility
     */
    SURGICAL_BENEFITS_MINUS_FACILITY = "CD",
    /**
     * Mental Health Provider - Inpatient
     */
    MENTAL_HEALTH_PROVIDER_MINUS_INPATIENT = "CE",
    /**
     * Mental Health Provider - Outpatient
     */
    MENTAL_HEALTH_PROVIDER_MINUS_OUTPATIENT = "CF",
    /**
     * Mental Health Facility - Inpatient
     */
    MENTAL_HEALTH_FACILITY_MINUS_INPATIENT = "CG",
    /**
     * Mental Health Facility - Outpatient
     */
    MENTAL_HEALTH_FACILITY_MINUS_OUTPATIENT = "CH",
    /**
     * Substance Abuse Facility - Inpatient
     */
    SUBSTANCE_ABUSE_FACILITY_MINUS_INPATIENT = "CI",
    /**
     * Substance Abuse Facility - Outpatient
     */
    SUBSTANCE_ABUSE_FACILITY_MINUS_OUTPATIENT = "CJ",
    /**
     * Screening X-ray
     */
    SCREENING_X_RAY = "CK",
    /**
     * Screening laboratory
     */
    SCREENING_LABORATORY = "CL",
    /**
     * Mammogram, High Risk Patient
     */
    MAMMOGRAM_HIGH_RISK_PATIENT = "CM",
    /**
     * Mammogram, Low Risk Patient
     */
    MAMMOGRAM_LOW_RISK_PATIENT = "CN",
    /**
     * Flu Vaccination
     */
    FLU_VACCINATION = "CO",
    /**
     * Eyewear and Eyewear Accessories
     */
    EYEWEAR_AND_EYEWEAR_ACCESSORIES = "CP",
    /**
     * Case Management
     */
    CASE_MANAGEMENT = "CQ",
    /**
     * Dermatology
     */
    DERMATOLOGY = "DG",
    /**
     * Durable Medical Equipment
     */
    DURABLE_MEDICAL_EQUIPMENT = "DM",
    /**
     * Diabetic Supplies
     */
    DIABETIC_SUPPLIES = "DS",
    /**
     * Generic Prescription Drug - Formulary
     */
    GENERIC_PRESCRIPTION_DRUG_MINUS_FORMULARY = "GF",
    /**
     * Generic Prescription Drug - Non-Formulary
     */
    GENERIC_PRESCRIPTION_DRUG_MINUS_NON_FORMULARY = "GN",
    /**
     * Allergy
     */
    ALLERGY = "GY",
    /**
     * Intensive Care
     */
    INTENSIVE_CARE = "IC",
    /**
     * Mental Health
     */
    MENTAL_HEALTH = "MH",
    /**
     * Neonatal Intensive Care
     */
    NEONATAL_INTENSIVE_CARE = "NI",
    /**
     * Oncology
     */
    ONCOLOGY = "ON",
    /**
     * Physical Therapy
     */
    PHYSICAL_THERAPY = "PT",
    /**
     * Pulmonary
     */
    PULMONARY = "PU",
    /**
     * Renal
     */
    RENAL = "RN",
    /**
     * Residential Psychiatric Treatment
     */
    RESIDENTIAL_PSYCHIATRIC_TREATMENT = "RT",
    /**
     * Transitional Care
     */
    TRANSITIONAL_CARE = "TC",
    /**
     * Transitional Nursery Care
     */
    TRANSITIONAL_NURSERY_CARE = "TN",
    /**
     * Urgent Care
     */
    URGENT_CARE = "UC"
}

export namespace ServiceTypeCode {
    export const SCHEMA: import_1.ElementSchema = { id: "1365", name: "Service Type Code", structure: { type: "simple", dataType: { type: "identifier", codes: [{ name: "Medical Care", value: "1" }, { name: "Surgical", value: "2" }, { name: "Consultation", value: "3" }, { name: "Diagnostic X-Ray", value: "4" }, { name: "Diagnostic Lab", value: "5" }, { name: "Radiation Therapy", value: "6" }, { name: "Anesthesia", value: "7" }, { name: "Surgical Assistance", value: "8" }, { name: "Other Medical", value: "9" }, { name: "Non-escrow or Non-impound Service", value: "B" }, { name: "Escrow or Impound Service", value: "C" }, { name: "Blood Charges", value: "10" }, { name: "Used Durable Medical Equipment", value: "11" }, { name: "Durable Medical Equipment Purchase", value: "12" }, { name: "Ambulatory Service Center Facility", value: "13" }, { name: "Renal Supplies in the Home", value: "14" }, { name: "Alternate Method Dialysis", value: "15" }, { name: "Chronic Renal Disease (CRD) Equipment", value: "16" }, { name: "Pre-Admission Testing", value: "17" }, { name: "Durable Medical Equipment Rental", value: "18" }, { name: "Pneumonia Vaccine", value: "19" }, { name: "Second Surgical Opinion", value: "20" }, { name: "Third Surgical Opinion", value: "21" }, { name: "Social Work", value: "22" }, { name: "Diagnostic Dental", value: "23" }, { name: "Periodontics", value: "24" }, { name: "Restorative", value: "25" }, { name: "Endodontics", value: "26" }, { name: "Maxillofacial Prosthetics", value: "27" }, { name: "Adjunctive Dental Services", value: "28" }, { name: "Health Benefit Plan Coverage", value: "30" }, { name: "Benefit Disclaimer", value: "31" }, { name: "Plan Waiting Period", value: "32" }, { name: "Chiropractic", value: "33" }, { name: "Chiropractic Office Visits", value: "34" }, { name: "Dental Care", value: "35" }, { name: "Dental Crowns", value: "36" }, { name: "Dental Accident", value: "37" }, { name: "Orthodontics", value: "38" }, { name: "Prosthodontics", value: "39" }, { name: "Oral Surgery", value: "40" }, { name: "Routine (Preventive) Dental", value: "41" }, { name: "Home Health Care", value: "42" }, { name: "Home Health Prescriptions", value: "43" }, { name: "Home Health Visits", value: "44" }, { name: "Hospice", value: "45" }, { name: "Respite Care", value: "46" }, { name: "Hospital", value: "47" }, { name: "Hospital - Inpatient", value: "48" }, { name: "Hospital - Room and Board", value: "49" }, { name: "Hospital - Outpatient", value: "50" }, { name: "Hospital - Emergency Accident", value: "51" }, { name: "Hospital - Emergency Medical", value: "52" }, { name: "Hospital - Ambulatory Surgical", value: "53" }, { name: "Long Term Care", value: "54" }, { name: "Major Medical", value: "55" }, { name: "Medically Related Transportation", value: "56" }, { name: "Air Transportation", value: "57" }, { name: "Cabulance", value: "58" }, { name: "Licensed Ambulance", value: "59" }, { name: "General Benefits", value: "60" }, { name: "In-vitro Fertilization", value: "61" }, { name: "MRI/CAT Scan", value: "62" }, { name: "Donor Procedures", value: "63" }, { name: "Acupuncture", value: "64" }, { name: "Newborn Care", value: "65" }, { name: "Pathology", value: "66" }, { name: "Smoking Cessation", value: "67" }, { name: "Well Baby Care", value: "68" }, { name: "Maternity", value: "69" }, { name: "Transplants", value: "70" }, { name: "Audiology Exam", value: "71" }, { name: "Inhalation Therapy", value: "72" }, { name: "Diagnostic Medical", value: "73" }, { name: "Private Duty Nursing", value: "74" }, { name: "Prosthetic Device", value: "75" }, { name: "Dialysis", value: "76" }, { name: "Otological Exam", value: "77" }, { name: "Chemotherapy", value: "78" }, { name: "Allergy Testing", value: "79" }, { name: "Immunizations", value: "80" }, { name: "Routine Physical", value: "81" }, { name: "Family Planning", value: "82" }, { name: "Infertility", value: "83" }, { name: "Abortion", value: "84" }, { name: "AIDS", value: "85" }, { name: "Emergency Services", value: "86" }, { name: "Cancer", value: "87" }, { name: "Pharmacy", value: "88" }, { name: "Free Standing Prescription Drug", value: "89" }, { name: "Mail Order Prescription Drug", value: "90" }, { name: "Brand Name Prescription Drug", value: "91" }, { name: "Generic Prescription Drug", value: "92" }, { name: "Podiatry", value: "93" }, { name: "Podiatry - Office Visits", value: "94" }, { name: "Podiatry - Nursing Home Visits", value: "95" }, { name: "Professional (Physician)", value: "96" }, { name: "Anesthesiologist", value: "97" }, { name: "Professional (Physician) Visit - Office", value: "98" }, { name: "Professional (Physician) Visit - Inpatient", value: "99" }, { name: "Professional (Physician) Visit - Outpatient", value: "A0" }, { name: "Professional (Physician) Visit - Nursing Home", value: "A1" }, { name: "Professional (Physician) Visit - Skilled Nursing Facility", value: "A2" }, { name: "Professional (Physician) Visit - Home", value: "A3" }, { name: "Psychiatric", value: "A4" }, { name: "Psychiatric - Room and Board", value: "A5" }, { name: "Psychotherapy", value: "A6" }, { name: "Psychiatric - Inpatient", value: "A7" }, { name: "Psychiatric - Outpatient", value: "A8" }, { name: "Rehabilitation", value: "A9" }, { name: "Rehabilitation - Room and Board", value: "AA" }, { name: "Rehabilitation - Inpatient", value: "AB" }, { name: "Rehabilitation - Outpatient", value: "AC" }, { name: "Occupational Therapy", value: "AD" }, { name: "Physical Medicine", value: "AE" }, { name: "Speech Therapy", value: "AF" }, { name: "Skilled Nursing Care", value: "AG" }, { name: "Skilled Nursing Care - Room and Board", value: "AH" }, { name: "Substance Abuse", value: "AI" }, { name: "Alcoholism", value: "AJ" }, { name: "Drug Addiction", value: "AK" }, { name: "Vision (Optometry)", value: "AL" }, { name: "Frames", value: "AM" }, { name: "Routine Exam", value: "AN" }, { name: "Lenses", value: "AO" }, { name: "Nonmedically Necessary Physical", value: "AQ" }, { name: "Experimental Drug Therapy", value: "AR" }, { name: "Burn Care", value: "B1" }, { name: "Brand Name Prescription Drug - Formulary", value: "B2" }, { name: "Brand Name Prescription Drug - Non-Formulary", value: "B3" }, { name: "Independent Medical Evaluation", value: "BA" }, { name: "Partial Hospitalization (Psychiatric)", value: "BB" }, { name: "Day Care (Psychiatric)", value: "BC" }, { name: "Cognitive Therapy", value: "BD" }, { name: "Massage Therapy", value: "BE" }, { name: "Pulmonary Rehabilitation", value: "BF" }, { name: "Cardiac Rehabilitation", value: "BG" }, { name: "Pediatric", value: "BH" }, { name: "Nursery", value: "BI" }, { name: "Skin", value: "BJ" }, { name: "Orthopedic", value: "BK" }, { name: "Cardiac", value: "BL" }, { name: "Lymphatic", value: "BM" }, { name: "Gastrointestinal", value: "BN" }, { name: "Endocrine", value: "BP" }, { name: "Neurology", value: "BQ" }, { name: "Eye", value: "BR" }, { name: "Invasive Procedures", value: "BS" }, { name: "Gynecological", value: "BT" }, { name: "Obstetrical", value: "BU" }, { name: "Obstetrical/Gynecological", value: "BV" }, { name: "Mail Order Prescription Drug: Brand Name", value: "BW" }, { name: "Mail Order Prescription Drug: Generic", value: "BX" }, { name: "Physician Visit - Office: Sick", value: "BY" }, { name: "Physician Visit - Office: Well", value: "BZ" }, { name: "Coronary Care", value: "C1" }, { name: "Private Duty Nursing - Inpatient", value: "CA" }, { name: "Private Duty Nursing - Home", value: "CB" }, { name: "Surgical Benefits - Professional (Physician)", value: "CC" }, { name: "Surgical Benefits - Facility", value: "CD" }, { name: "Mental Health Provider - Inpatient", value: "CE" }, { name: "Mental Health Provider - Outpatient", value: "CF" }, { name: "Mental Health Facility - Inpatient", value: "CG" }, { name: "Mental Health Facility - Outpatient", value: "CH" }, { name: "Substance Abuse Facility - Inpatient", value: "CI" }, { name: "Substance Abuse Facility - Outpatient", value: "CJ" }, { name: "Screening X-ray", value: "CK" }, { name: "Screening laboratory", value: "CL" }, { name: "Mammogram, High Risk Patient", value: "CM" }, { name: "Mammogram, Low Risk Patient", value: "CN" }, { name: "Flu Vaccination", value: "CO" }, { name: "Eyewear and Eyewear Accessories", value: "CP" }, { name: "Case Management", value: "CQ" }, { name: "Dermatology", value: "DG" }, { name: "Durable Medical Equipment", value: "DM" }, { name: "Diabetic Supplies", value: "DS" }, { name: "Generic Prescription Drug - Formulary", value: "GF" }, { name: "Generic Prescription Drug - Non-Formulary", value: "GN" }, { name: "Allergy", value: "GY" }, { name: "Intensive Care", value: "IC" }, { name: "Mental Health", value: "MH" }, { name: "Neonatal Intensive Care", value: "NI" }, { name: "Oncology", value: "ON" }, { name: "Physical Therapy", value: "PT" }, { name: "Pulmonary", value: "PU" }, { name: "Renal", value: "RN" }, { name: "Residential Psychiatric Treatment", value: "RT" }, { name: "Transitional Care", value: "TC" }, { name: "Transitional Nursery Care", value: "TN" }, { name: "Urgent Care", value: "UC" }] }, length: { max: 2, min: 1 } } };
}
